import { StyledPlank } from '~/src/layout/login/styled';
import { raz, tryStr } from '~/src/helpers/declOfNumCallection';
import React from 'react';
import { MAX_TRY_LOGIN_COUNT } from '~/src/constants';
import { connect } from 'react-redux';
import { clearInvalidLogin } from '~/src/store/actions/auth';
import { RenderBlockedMessage } from '~/src/components/Login/ErrorBlockedMessage';

/**
 * @param {Number} count
 * @param {Date} expires
 * @param {function} clearInvalidLogin
 * @return {JSX.Element|null}
 * @constructor
 */
function ErrorMessage({ invalidLogin: { count, expires }, clearInvalidLogin }) {
    if (count <= 2) {
        return null;
    }
    const tryCount = MAX_TRY_LOGIN_COUNT - count;
    if (tryCount <= 0) {
        return <RenderBlockedMessage expires={expires} clearInvalidLogin={clearInvalidLogin}/>;
    }
    return <StyledPlank>
        Вы {count} {raz(count)} указали неверные данные.<br/>
        У вас осталось еще {tryCount} {tryStr(tryCount)}.<br/> После этого
        доступ к личному кабинету будет заблокирован на 1 час.
    </StyledPlank>;
}

function mapStateToProps(state) {
    return {
        invalidLogin: state.auth.invalidLogin,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clearInvalidLogin: () => dispatch(clearInvalidLogin()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorMessage);
